/**
* Created by elmer on 28/06/17.
*/
<style>

    #app {
        overflow: hidden;
        min-height: 100%;
    }

    #app, html {
        position: relative;
    }

    .layout{
        background: #f6f7fb;
        position: relative;
        /*border: 1px solid #d7dde4;
        border-radius: 4px;*/
        overflow: hidden;
        width: 100%;
        display: flex;
        flex: 1;
        flex-direction: column;
    }

    .layout-side-left {
        float: left;
    }

    .layout-center {
        width:150px;
        display: flex;
        -webkit-display: flex;
        flex-direction: row;
        -webkit-flex-direction: row;
        justify-content: center;
        -webkit-justify-content: center;
        align-items: center;
        -webkit-align-items: center;
    }

    .layout-side-right {

    }

    .layout-copy{
        text-align: center;
        padding: 10px 0 20px;
        color: #9ea7b4;
    }

    .main-content {
        flex: 1;
        flex-direction: column;
        padding: 15px 40px;
    }

    .pantallas-header-btn > span, .span-centered {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: row;
    }

    .span-centered {
        min-width: 100px;
    }

    .pantallas-header-text {
        margin-left: 10px;
        font-weight: bold;
        color: #afafb0;
        font-size: 1.1em;
    }
</style>

<template>
    <div class="layout" style="min-height: 100vh;">
        <Menu mode="horizontal" @on-menu-item-select="onMenuItemSelect($event)" style="display:flex;justify-content: space-between;box-shadow: 0 1px 1px rgba(0,0,0,.08);">
            <div class="layout-side-left">
                <i-button type="text" class="pantallas-header-btn" @click="goToHome()">
                    <Icon type="ios-keypad-outline" size="25" color="#afafb0" style="font-weight: bold;"></Icon>
                    <span class="pantallas-header-text">Camapañas</span>
                </i-button>
            </div>
            <div class="layout-center">
                <img src="/static/img/logo-pantallas.png" alt="" style="width:auto;height:50px;">
            </div>
            <div class="layout-side-right">
                <Dropdown trigger="click" @on-click="onDropdownClick($event)">
                    <i-button type="text" class="pantallas-header-btn">
                        <Icon type="person" size="26" color="#afafb0"></Icon>
                        <span class="pantallas-header-text mr5">{{$store.state.user.nombre_completo}}</span>
                        <Icon type="arrow-down-b" color="#afafb0"></Icon>
                    </i-button>
                    <Dropdown-menu slot="list">
                        <Dropdown-item name="profile">
                            <span class="span-centered">
                                <Icon type="ios-cog-outline" color="#afafb0" size="22"></Icon>
                                <span class="ml5">
                                    Mi Perfil
                                </span>
                            </span>
                        </Dropdown-item>
                        <Dropdown-item name="logout" divided>
                            <span class="span-centered">
                                <Icon type="ios-undo-outline" color="#afafb0" size="22"></Icon>
                                <span class="ml5">
                                    Cerrar sesión
                                </span>
                            </span>
                        </Dropdown-item>
                    </Dropdown-menu>
                </Dropdown>
            </div>
        </Menu>
        <div class="main-content">
            <transition name="fade" mode="out-in">
                <router-view name="main"></router-view>
            </transition>
        </div>
        <div class="layout-copy">
            {{ currentYear }} &copy; Pantallas
        </div>
    </div>
</template>

<script>
  import moment from 'moment';

  export default {
    data() {
      return {
        menuOpened: false,
      };
    },
    head: {
      title: {
        inner: 'Administrador de Campañas',
      },
    },
    created() {
      console.log(this.$router);
      console.log(this.$store);
    },
    computed: {
      currentYear() {
        return moment().format('YYYY');
      },
    },
    methods: {
      onLogout() {
        const self = this;
        this.$Modal.confirm({
          title: 'Cerrar Sesión',
          content: '<p>¿Está seguro que desea salir del sistema?</p>',
          okText: 'Estoy seguro',
          cancelText: 'Cancelar',
          onOk() {
            self.$store.commit('logout');
            self.$router.replace({ path: '/login' });
          },
        });
      },
      goToHome() {
        this.$router.push({
          path: `/admin/campaigns`,
        });
      },
      onDropdownClick(dropdownItem) {
        if (dropdownItem === 'logout') {
          this.onLogout();
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Layout.vue?14ee5b35